import { cva } from "class-variance-authority";

// Gets CSS styles for the select trigger based on the variant
export const selectVariants = cva("font-inter text-base font-medium leading-[130%] text-left cursor-pointer inline-flex whitespace-nowrap select-none mt-0 transition-all", {
  variants: {
    variant: {
      primary: [
        "border-[var(--primary-cta)] text-app-primary-cta border-[2px]",
        "hover:bg-[color-mix(in_srgb,var(--primary-cta-high-contrast)_10%,transparent)]",
        "focus-visible:bg-[color-mix(in_srgb,var(--primary-cta-high-contrast)_10%,transparent)]",
        "disabled:opacity-30 disabled:hover:bg-app-document-background disabled:border-[var(--primary-cta)] disabled:text-app-primary-cta",
      ],
      secondary: [
        "border-app-grey-0 text-app-grey-0 fill-app-grey-0 [&_svg>path]:fill-app-grey-0 bg-transparent border-[2px]",
        "hover:bg-[color-mix(in_srgb,var(--menu-color-hover),transparent)]",
        "focus-visible:bg-[color-mix(in_srgb,var(--menu-color-hover),transparent)]",
        "disabled:opacity-30 disabled:hover:bg-app-document-background disabled:border-app-grey-0 disabled:text-app-grey-0 disabled:fill-app-grey-0 disabled:[&_svg>path]:fill-app-grey-0",
      ],
      tertiary: [
        "border-app-grey-3 text-app-grey-0 fill-app-grey-2 [&_svg>path]:fill-app-grey-2 bg-transparent border-[1px]",
        "hover:bg-app-grey-3 hover:border-app-grey-3 hover:text-app-grey-0",
        "focus-visible:bg-app-grey-3 focus-visible:border-app-grey-3 focus-visible:text-app-grey-0",
        "disabled:opacity-30 disabled:hover:bg-app-document-background disabled:border-app-grey-3 disabled:text-app-grey-0 disabled:fill-app-grey-0 disabled:[&_svg>path]:fill-app-grey-0",
      ],
      translucent: [
        "border-app-primary-cta-translucent text-app-primary-cta fill-primary-cta-translucent [&_svg>path]:fill-app-primary-cta bg-app-primary-cta-translucent border-[1px]",
        "hover:bg-app-primary-cta-transparent-30 hover:border-app-primary-cta-transparent-30 hover:text-app-primary-cta hover:fill-app-primary-cta hover:[&_svg>path]:fill-app-primary-cta",
        "focus-visible:bg-app-primary-cta focus-visible:border-app-primary-cta focus-visible:text-app-cta-text-color focus-visible:fill-app-cta-text-color focus-visible:[&_svg>path]:fill-app-cta-text-color",
        "disabled:opacity-30 disabled:hover:bg-app-primary-cta-translucent disabled:border-app-primary-cta-translucent disabled:text-app-primary-cta disabled:fill-app-primary-cta disabled:[&_svg>path]:fill-app-primary-cta",
      ],
      iconprimary: ["[&_path]:fill-[var(--primary-cta)] group-disabled:[&_path]:fill-[var(--primary-cta)] group-active:[&_path]:fill-[var(--cta-text-color)]"],
      iconsecondary: ["[&_path]:fill-[var(--grey-0)] group-disabled:[&_path]:fill-[var(--grey-0)]"],
      icontranslucent: [
        "[&_path]:fill-[var(--primary-cta)] group-disabled:[&_path]:fill-[var(--primary-cta)] group-hover:[&_path]:fill-[var(--primary-cta)] group-focus-visible:[&_path]:fill-[var(--cta-text-color)]",
      ],
    },
  },
  defaultVariants: {
    variant: "tertiary",
  },
});

// Gets CSS styles for the select options based on the variant and selected state
export const optionVariants = cva(
  "transition-all h-[40px] w-full relative flex cursor-pointer select-none items-center rounded px-0 mb-2 last:mb-0 data-[disabled]:pointer-events-none group-aria-selected:[&:not(:active)]:rounded-[10px] group-aria-selected:[&:not(:active)]:before:rounded-[10px] group-focus:before:rounded-[10px] group-focus:rounded-[10px] data-[highlighted]:rounded-[10px]",
  {
    variants: {
      variant: {
        default: [
          "text-app-grey-0 [&>path]:fill-app-grey-0",
          "group-focus:before:bg-[var(--menu-color-hover)]",
          "group-hover:before:bg-[var(--menu-color-hover)]",
          "group-aria-selected:[&:not(:active)]:bg-[var(--menu-color-hover)]",
          "group-active:before:bg-[var(--menu-color-active)]",
        ],
        success: [
          "text-app-success-color [&>path]:success-color",
          "group-focus:before:bg-[var(--success-color-hover)]",
          "group-hover:before:bg-[var(--success-color-hover)]",
          "group-aria-selected:[&:not(:active)]:bg-[var(--menu-color-hover)]",
          "group-active:before:bg-[var(--success-color-active)]",
        ],
        danger: [
          "text-app-danger-color [&>path]:fill-app-danger-color",
          "group-focus:before:bg-[var(--danger-color-hover)]",
          "group-hover:before:bg-[var(--danger-color-hover)]",
          "group-aria-selected:[&:not(:active)]:bg-[var(--menu-color-hover)]",
          "group-active:before:bg-[var(--danger-color-active)]",
        ],
      },
    },
    compoundVariants: [
      {
        variant: "default",
        selected: true,
        className:
          "rounded-[10px] text-app-grey-0 group-aria-selected:[&:not(:active)]:bg-[var(--menu-color-hover)] hover:before:bg-[var(--menu-color-hover)] active:before:bg-[var(--menu-color-active)]",
      },
      {
        variant: "success",
        selected: true,
        className:
          "rounded-[10px] text-app-success-color group-aria-selected:[&:not(:active)]:bg-[var(--success-color-hover)] hover:before:bg-[var(--success-color-hover)] active:before:bg-[var(--success-color-active)]",
      },
      {
        variant: "danger",
        selected: true,
        className:
          "rounded-[10px] text-app-danger-color group-aria-selected:[&:not(:active)]:bg-[var(--danger-color-hover)] hover:before:bg-[var(--danger-color-hover)] active:before:bg-[var(--danger-color-active)]",
      },
    ],
    defaultVariants: {
      variant: "default",
    },
  }
);

// Define text color and loading colors based on variant
export const getTextLoadingColor = (state, variant) => {
  if (state === "loading") {
    switch (variant) {
      case "primary":
        return "text-app-cta-text-color"; // White text for primary variants in loading state
      case "tertiary":
        return "text-app-primary-cta-high-contrast";
      default:
        return "text-app-grey-0";
    }
  }
};
